<template>
  <splash v-show="isLoading" title="본격독해 준비중..." />
  <splash v-show="isProc" title="잠시만 기다려 주세요." />
  <q-header reveal elevated class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
    <!-- <q-toolbar style="justify-content: space-between; padding:0 3.75vmin ;">
      <q-icon name="img:/assets/images/icon/icon_home.svg" size="20px" :onclick="onClickHome" />
      <div style="display: flex; margin-left: 20px;">
        <q-btn flat icon="arrow_back_ios_new" :onClick="() => { nextExam(true); }" />
        <q-select filled v-model="model" use-input hide-selected fill-input input-debounce="0" :options="options"
          @filter="filterFn" style="width: 250px; ">
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No results
              </q-item-section>
            </q-item>
          </template>
        </q-select>
        <q-btn flat icon="arrow_forward_ios" :onClick="() => { nextExam(); }" />
      </div>
    </q-toolbar> -->

    <q-toolbar style="justify-content: space-between; padding:0 3.75vmin ;">
      <div style="height: 7.17vmin; display: flex; align-items: center;">
        <q-icon name="arrow_back_ios" size="1.85vw" :onclick="onClickHome" style="cursor: pointer" />
        <q-select filled v-model="levelModel" use-input hide-selected fill-input input-debounce="0"
          :options="levelOptions" style="width: 100px; " @update:model-value="modelChange">
        </q-select>
        <q-select filled v-model="lessonModel" use-input hide-selected fill-input input-debounce="0"
          :options="lessonList" style="width: 100px; " @update:model-value="modelChange">
        </q-select>
        <q-select filled v-model="lnModel" use-input hide-selected fill-input input-debounce="0" :options="lnOptions"
          style="width: 100px; " @update:model-value="modelChange">
        </q-select>
        <q-btn flat icon="arrow_back_ios_new" :onClick="() => { nextExam(true); }" />
        <q-select filled v-model="model" use-input hide-selected fill-input input-debounce="0" :options="options"
          @filter="filterFn" style="width: 250px; " @update:model-value="examModelChange">
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                No results
              </q-item-section>
            </q-item>
          </template>
        </q-select>
        <q-btn flat icon="arrow_forward_ios" :onClick="() => { nextExam(); }" />
      </div>
      <div style="padding: 14px">
        <q-btn rounded icon-right="arrow_forward_ios" label="코어독해" :onClick="() => { nextExam(); }" />&nbsp;
        <q-btn rounded icon-right="arrow_forward_ios" label="본격독해" :onClick="() => { nextExam(); }" />&nbsp;
        <q-btn rounded icon-right="arrow_forward_ios" label="어휘학습" :onClick="() => { nextExam(); }" />&nbsp;
        <q-btn rounded icon-right="arrow_forward_ios" label="진단평가" :onClick="() => { nextExam(); }" />&nbsp;
        <q-btn rounded icon-right="arrow_forward_ios" label="수능" :onClick="() => { nextExam(); }" />&nbsp;
      </div>
    </q-toolbar>
  </q-header>
  <q-page-container v-if="!isLoading" style="height: 100%;">
    <q-page class="pd_all_16" style="height: calc( 100vh  - 9.83vmin )">
      <div class="row" style="height: 100%;">
        <div class="col passage" style="height: 100%;">
          <qbankHeaderVue :questionHeader="questionHeader" :inputIdx="inputIdx" :bookNm="bookNm"
            @isChangeHeader="() => { isChangeHeader = true; }" />
        </div>
        <div class="col answer" style="height: 100%;">
          <!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
              @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
          <q-scroll-area v-if="!relationDialog" ref="scrollAreaRef" visible style="height: calc(100% - 1.99vmin);"
            class="answer__scroll">
            <div>
              <problemChoice :p-content="problem" v-if="problem" @setAnswer="setAnswer" />
            </div>
            <div>{{
                problems[problemOrder]?.data.content.solution.answer.detail[0].answer
            }}
            </div>
            <div>
              <qbankAnswer :p-content="problem" v-if="problem?.data" @onIntersection="onIntersection"
                @setVideoStatus="setVideoStatus" />
            </div>

          </q-scroll-area>
          <div v-if="relationDialog">
            <problemRelation :p-content="problem" v-if="problem" @setRelationAnswer="setRelationAnswer"
              @onClose="() => { relationDialog = false; }" @setMessage="(m) => { msg = m; }" />
          </div>
          <modalLayer v-if="store.visibleModal" width="400px">
            <div style="font-size: x-large;font-weight: bold; text-align: center;">
              채점 결과
            </div>
            <br />
            <div style="padding: 0px 20px;">
              <div v-for="(item, index) in resultData.data"
                style="display: flex;padding: 10px 20px;border-radius: 8px;background-color: #F7F7F7; margin-top: 5px; position: relative;">
                <AnswerMarking :marking-class="'marking-' + item.marking" />
                <div style="padding: 0px 20px 0px 12px ;">{{ item.no }}.</div>
                <div>{{ item.analysis }} / &nbsp;</div>
                <div>{{ item.difficult }}</div>
              </div>
            </div>
            <div style="margin: 10px 0px;  font-weight: bold; text-align: center;">
              {{ resultData?.right && resultData?.right !== 0 ? resultData?.right + '개의 정답' : '' }}{{ resultData?.right
                  && (resultData?.right
                    !== 4 &&
                    resultData?.right !== 0) ? ',' : ''
              }} {{ resultData?.wrong && resultData?.wrong !== 0 ? resultData?.wrong + '개의 오답' : '' }}을 받았어요.<br />
              정답, 오답 문제를 확인해봐요.
            </div>
            <div style="text-align: center;">
              <cqBtn @onClickFn="() => {
                // problemOrder = 1; problem = problems[1]; 
                notiType = 'first';
                nextStep(false, 1);
                isScored = true; store.visibleModal = false;
              
              }" :options="{ sound: 'next' }" color="primary" label="채점 확인하기" />
            </div>
          </modalLayer>
        </div>
      </div>
    </q-page>
    <FloatingNotify :text="msg" :icon="msgIcon" @resetMsg="() => { msg = '' }" />
    <!-- <FloatingBtn :visible="nextBtn" @on-click="() => { nextBtnAction(); }" /> -->
    <FloatingBtn :visible="true" :text="nextBtn && isCompleteBtn ? '본격독해 완료' : null"
      :bgColor="nextBtn && isCompleteBtn ? '#222222' : null" :icon="nextBtn && isCompleteBtn ? 'done' : null"
      @on-click="() => { nextStep(); }" :class="nextBtn && isCompleteBtn ? 'answer--txt' : 'answer--next'" />
    <FloatingBtn :visible="true" position="left" @on-click="() => { nextStep(false); }" class="answer--prev" />
    <FloatingBtn :visible="scoreBtn" text="정답 확인" text-only="true" bgColor="#FF4E7C"
      @on-click="() => { scoreBtn && setQuestionsResult() }" class="answer--txt"
      bottom="calc( 15.83vmin - 4.9vw - 0.83vmin )" />
  </q-page-container>
  <!-- <FloatingBtn :visible="true" @on-click="() => { nextStep(); }" /> -->
  <!-- <FloatingBtn :visible="true" position="left" @on-click="() => { nextStep(false); }" /> -->
  <!-- <div style="border-radius: 20px;
    background-color: #d5d5d5db;
    padding: 10px;
    margin: 10px;
    display: inline-flex;
    align-items: center;
    color: gray;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 999999999999;">
    <div>다음문제</div><q-icon name="arrow_forward_ios" />
  </div>
  <div style="border-radius: 20px;
    background-color: #d5d5d5db;
    padding: 10px;
    margin: 10px;
    display: inline-flex;
    align-items: center;
    color: gray;
    position: fixed;
  bottom: 0px;
    z-index: 999999999999;"><q-icon name="arrow_back_ios_new" />
  </div> -->
</template>

<script setup>
import { historyBack } from "@/helpers/utils"
import splash from "@/components/template/splash.vue"
import { ref, onMounted, onUnmounted, watch, toRaw } from "vue";
import { DialogStore } from "@/store/modules/dialog";
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from "@/components/qbank/header.vue";
import problemChoice from "@/components/qbank/problemChoice.vue";
import qbankAnswer from "@/components/qbank/qbankAnswer.vue";
import AnswerMarking from "@/components/qbank/answerMarking.vue";
import studyHeader from "@/components/layouts/header/studyHeader.vue";
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtProblem } from "@/api/modules/qbank";
import dataToParse from "@/helpers/qbankParser/dataParse";
import { getHeaderTitle, getKreadScore, getHeaderText, getEtcInfo, getHeader } from "@/helpers/qbankParser/qbankDataParse";
import { useQuasar } from 'quasar'
import moment from "moment";
import { soundEffect, soundTic } from "@/helpers/soundEffect";
import { StudyStore } from "@/store/modules/study";
import { useRoute, useRouter } from "vue-router"
import cqBtn from "@/components/quasar/cqBtn.vue"
import _ from "lodash"
import ProblemRelation from "@/components/qbank/problemRelation.vue";
import { analysis, difficult, drill } from "@/helpers/qbankParser/qbankMeta";
import { postAnswerEarnest } from "@/api/modules/study";
import { examsData } from "@/views/testPage/examsData";
import FloatingBtn from "@/components/quasar/floatingBtn.vue";
import FloatingNotify from "@/components/quasar/floatingNotify.vue";

const route = useRoute()
// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const loadingTime = 1000;
const store = DialogStore();
const studyStore = StudyStore();
const isLoading = ref(null);
const isProc = ref(null);
const isKreadVisible = ref(null);
const data = ref(null);
const diffTime = ref(null);
let startTime;
let baseTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false;  // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiAnswer = null;
let notiInfo = null;
let notiNav = null;
let notiAdditionalNav = null;
let notiNavBack = null;
let notiScoring = null;
let notiType = 'first';
let isScored = false;
let isDrill = false;
let isAllChecked = false;

const dialog = ref(false);
const videoDialog = ref(false);
const resultDialog = ref(false);
const relationId = ref(null);
const scrollAreaRef = ref(null)

const initCoreReading = (rs) => {
  // console.log(rs);
  isLoading.value = false;
  // isKreadVisible.value = true;
  // store.openModal(true);
  const tmpEtcInfo = getEtcInfo(rs);
  data.value = {
    content: getHeaderText(rs),
    kread: tmpEtcInfo.kread,
    title: tmpEtcInfo.title,
    etcInfo: tmpEtcInfo,
    standardReadingTime: moment('2022-10-01 00:00:00').add(tmpEtcInfo.solveTime, 's').format('m분ss초'),
    solveTime: tmpEtcInfo.solveTime
  };
  questionHeader.value = null;
  questionHeader.value = getHeader(rs);
  // console.log('*************************************************************');
  // console.log(tmpEtcInfo.bookNm);
  // console.log('*************************************************************');
  bookNm.value = tmpEtcInfo.bookNm;
  startTime = moment();
  // setNotiNavigation(problems[problemOrder.value]);
}


const nextStep = (v = true, no = -1) => {
  isProc.value = true;
  soundEffect('next');
  if (dialog.value !== false) {
    // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
    dialog.value = false;
  }
  // if (!problems[problemOrder.value]?.startDtm) {
  //   problems[problemOrder.value].startDtm = moment().format('YYYY-MM-DD HH:mm:ss');
  // }
  if (problems[(problemOrder.value)] && problems[(problemOrder.value)]['result'] === null) {
    problems[(problemOrder.value)]['studyTime'] = problems[(problemOrder.value)]['studyTime'] + Math.round(moment.duration(moment().diff(startTime)).asSeconds());
  }
  startTime = moment();
  if (problems[(problemOrder.value)] && problems[(problemOrder.value)]['result'] !== null && problems[(problemOrder.value)]['result']['marking'] !== 'halfWrong') {
    problems[problemOrder.value]['done'] = true;
  }

  if (notiType === 'last' && v) {
    if (isDrill) {
      return saveResult();
      // return router.push('/vocabularylearning');
    } else {

      return saveResult();
      // return router.push('/authenticreading');
    }
  }
  if (no !== -1) {
    problemOrder.value = no;
  } else if (!v) {
    problemOrder.value = problemOrder.value - 1;
  } else {
    problemOrder.value = problemOrder.value + 1;
  }
  questionHeader.value === null && getHeader(problems[(problemOrder.value)].data)
  if (problemOrder.value === 1) {
    notiType = 'first'
    store.openModal(false);
    // questionHeader.value = getHeader(problems[(problemOrder.value)].data);
  } else if (problemOrder.value === Object.keys(problems).length) {
    notiType = 'last'
  } else {
    notiType = 'middle'
  }
  // problemOrder.value = problemOrder.value = 2;
  // getKrtProblem({
  //   version: '1.00.01', problemId: problemMaps[problemOrder.value].problemId
  // }, setProblem)
  problem.value = {
    ...problems[problemOrder.value]
  };

  if (problems[problemOrder.value].result?.marking === 'halfWrong') {
    $q.notify({
      // message: '오답은 한 번 다시 풀어보아요.',
      message: '다시 한 번 풀어 보세요.',
      // color: 'secondary',
      position: 'right',
      timeout: 1000
    })
  }
  notiClear();
  // setNotiNavigation(problems[problemOrder.value]);
  // notiNav !== null && notiNav();
  // notiNavBack !== null && notiNavBack();
  // notiNav = null;
  // notiNavBack = null;
  // startTime = moment();
  setScrollPosition();
  isProc.value = false;
}

const initExams = (v = null) => {
  // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
  // console.log(v);
  if (v === null) return;
  let problemArrId = [];
  allProblems = [];
  getKrtExam({
    // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
    // version: studyStore.exprVersion, examNm: studyStore.process.exam.examCode + '_R'
    version: studyStore.exprVersion, examNm: v + '_R'
  }, (rs) => {
    // TODO: store 에 코어리딩 문제 저장
    // rs.examMaps 
    if (rs && rs.examMaps) {
      const exId = rs.examIds[0];
      rs.examMaps[exId].forEach(item => {
        if (analysis[item.property.analysisId]) {
          allProblems.push({ ...item, analysisOrd: analysis[item.property.analysisId]['ord'] })
        }
      });
      // getKrtProblem({
      //   version: '1.00.01', problemId: rs.examMaps[exId][0].problemId
      //   // version: '1.00.01', problemId: 382222
      // }, initCoreReading);
      // Object.entries(studyStore.mapTree.difficult).forEach(([key, value]) => {
      //   const tmpProblemArr = [...allProblems];
      //   const item = _.filter(tmpProblemArr, item => { return (item.difficultCd === value && analysis[item.property.analysisId].ord === analysis[key].ord) });
      //   item.length > 0 && problemArrId.push(item[0]);
      //   console.log(item);
      // })
      allProblems.forEach(item => {
        // const tmpItem = studyStore.process.exam.difficult[item.property.analysisId];
        // TODO: 문항 검수용 전체 문제 보기
        // problemArrId.push(item);
        // if (tmpItem && tmpItem === item.difficultCd) {
        problemArrId.push(item);
        // }
        // const tmpProblemArr = [...allProblems];
        // const item = _.filter(tmpProblemArr, item => { return (item.difficultCd === value && analysis[item.property.analysisId].ord === analysis[key].ord) });
        // item.length > 0 && problemArrId.push(item[0]);
        // console.log(item);
      })
      // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$')
      // console.log(problemArrId)
      problemArrId.forEach((item, index) => {
        getKrtProblem({
          version: studyStore.exprVersion, problemId: item.problemId
          // version: '1.00.01', problemId: 382222
        }, (r) => {
          // console.log(r);
          // console.log(r.content.property.analysis.analysisId);
          problems = {
            ...problems,
            // TODO: 문항 검수용 전체 문제 보기
            // [index + 1]: {
            [index]: {
              problemNo: index + 1,
              problemId: r.content.problemId,
              analysisOrd: analysis[r.content.property.analysis.analysisId]['ord'],
              etcInfo: getEtcInfo(r),
              data: r,
              type: studyStore.process.exam.ln,
              studyTime: 0,
              answer: null,
              reAnswer: null,
              markingType: 'right', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
              videoTime: 0,
              relationResult: null,
              // 하단 네비 조정을 위한 변수
              result: null,              // 채점 여부및 1,2차 정오답 
              done: false,               // 채점및 풀이 확인 완료여부
              scrollCheck: false,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
              relationId: r.content.property.problem?.relations?.length > 0 ? r.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
              completeVideo: false,         // 영상 시청 여부
              // TODO: 큐뱅크 해설영상 파싱필요 
              videoUrl: null,              // 해설 영상 여부
              problemClassCode: '1',
              startDtm: null,
              endDtm: null
            }
          }
          if (index === 0) {
            initCoreReading(r);
          }
          problem.value = problems[0];
        });
      });

    }
  });
}
onMounted(() => {
  isLoading.value = true;
  isKreadVisible.value = false;
  // console.log('###########################################');
  // console.log(route.query.id);
  // console.log('###########################################');
  // setTimeout(() => {
  //   getCoreReacdingApi({}, (rs) => {
  //     isLoading.value = false;
  //     isKreadVisible.value = true;
  //     store.openModal(true);
  //     data.value = { ...rs, baseTime: moment('2022-10-01 00:00:00').add(rs.time, 's').format('m분ss초') };
  //   })
  // }, loadingTime);
  initExams(model.value);
  // getKrtExam({
  //   // version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
  //   version: studyStore.exprVersion, examNm: studyStore.process.exam.examCode + '_R'
  // }, (rs) => {
  //   // TODO: store 에 코어리딩 문제 저장
  //   // rs.examMaps 
  //   if (rs && rs.examMaps) {
  //     const exId = rs.examIds[0];
  //     rs.examMaps[exId].forEach(item => {
  //       if (analysis[item.property.analysisId]) {
  //         allProblems.push({ ...item, analysisOrd: analysis[item.property.analysisId]['ord'] })
  //       }
  //     });
  //     // getKrtProblem({
  //     //   version: '1.00.01', problemId: rs.examMaps[exId][0].problemId
  //     //   // version: '1.00.01', problemId: 382222
  //     // }, initCoreReading);
  //     let problemArrId = [];
  //     // Object.entries(studyStore.mapTree.difficult).forEach(([key, value]) => {
  //     //   const tmpProblemArr = [...allProblems];
  //     //   const item = _.filter(tmpProblemArr, item => { return (item.difficultCd === value && analysis[item.property.analysisId].ord === analysis[key].ord) });
  //     //   item.length > 0 && problemArrId.push(item[0]);
  //     //   console.log(item);
  //     // })
  //     allProblems.forEach(item => {
  //       const tmpItem = studyStore.process.exam.difficult[item.property.analysisId];
  //       // TODO: 문항 검수용 전체 문제 보기
  //       // problemArrId.push(item);
  //       if (tmpItem && tmpItem === item.difficultCd) {
  //         problemArrId.push(item);
  //       }
  //       // const tmpProblemArr = [...allProblems];
  //       // const item = _.filter(tmpProblemArr, item => { return (item.difficultCd === value && analysis[item.property.analysisId].ord === analysis[key].ord) });
  //       // item.length > 0 && problemArrId.push(item[0]);
  //       console.log(item);
  //     })
  //     console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$')
  //     console.log(problemArrId)
  //     problemArrId.forEach((item, index) => {
  //       getKrtProblem({
  //         version: studyStore.exprVersion, problemId: item.problemId
  //         // version: '1.00.01', problemId: 382222
  //       }, (r) => {

  //         problems = {
  //           ...problems,
  //           // TODO: 문항 검수용 전체 문제 보기
  //           // [index + 1]: {
  //           [item.analysisOrd]: {
  //             problemNo: index + 1,
  //             problemId: r.content.problemId,
  //             analysisOrd: item.analysisOrd,
  //             etcInfo: getEtcInfo(r),
  //             data: r,
  //             studyTime: 0,
  //             answer: null,
  //             reAnswer: null,
  //             markingType: 'right', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
  //             videoTime: 0,
  //             relationResult: null,
  //             correctiveStatus: false,
  //             totalCnt: 0,
  //             process: 1,
  //             // 하단 네비 조정을 위한 변수
  //             result: null,              // 채점 여부및 1,2차 정오답 
  //             done: false,               // 채점및 풀이 확인 완료여부
  //             scrollCheck: false,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
  //             relationId: r.content.property.problem?.relations.length > 0 ? r.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
  //             completeVideo: false,         // 영상 시청 여부
  //             // TODO: 큐뱅크 해설영상 파싱필요 
  //             videoUrl: null,              // 해설 영상 여부
  //           }
  //         }
  //         if (index === 0) {
  //           initCoreReading(r);
  //         }
  //         problem.value = problems[1];
  //       });
  //     });
  //   }
  // });
})


const answerNoti = () => {
  notiAnswer !== null && notiAnswer();
  notiAnswer = null;
  // if (notiAnswer === null) {
  //   notiAnswer = $q.notify({
  //     group: false,
  //     timeout: 0,
  //     message: '',
  //     multiLine: true,
  //     color: 'secondary',
  //     classes: 'force-inline',
  //     position: 'bottom-right',
  //     actions:
  //       [{ label: '정답 확인', color: 'yellow', handler: () => { notiAnswer = null; setQuestionsResult(); } }]
  //   });
  // }
}

onUnmounted(() => {
  notiClear();
  isLoading.value = true;
  store.openModal(false);
})

const notiClear = () => {
  notif !== null && notif();
  notiAnswer !== null && notiAnswer();
  notiNav !== null && notiNav();
  notiNavBack !== null && notiNavBack();
  notiAdditionalNav !== null && notiAdditionalNav();
  notif = null;
  notiAnswer = null;
  notiNav = null;
  notiNavBack = null;
  notiAdditionalNav = null;
}
// watch(() => problem.value, (newValue) => {
//   // const questionHeader = JSON.parse(JSON.stringify(newValue));
//   console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!' + newValue);
//   const vContent = toRaw(newValue);
//   console.log(vContent);
// });
// watch(() => problem.visibleScoring, (newValue) => {
//   // const questionHeader = JSON.parse(JSON.stringify(newValue));

// });


watch(() => studyStore.process, (newValue) => {
  isLoading.value = true;
  isKreadVisible.value = false;
  initExams();
});



const setAnswer = (val) => {
  // soundEffect('tic');
  if (problems[problemOrder.value]['result']) {
    problems[problemOrder.value]['reAnswer'] = val;
    // console.log(problems[problemOrder.value]['reAnswer']);
    // answerNoti();
    // setNotiNavigation(problems[problemOrder.value]);
  } else {
    problems[problemOrder.value]['answer'] = val;
    // console.log(problems[problemOrder.value]['answer']);
    const tmpAnswerArr = _.filter(problems, item => { return item.answer === null });
    if (tmpAnswerArr.length === 0) {
      // console.log('All Answers !!!!!!!!!!!!!!!');
      isAllChecked = true;
    }
    // setNotiNav(tmpAnswerArr.length === 0);
    // setNotiNavigation(problems[problemOrder.value], tmpAnswerArr.length === 0);
    // console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
    // console.log(problems);
    // console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
  }
  // Object.values(tmpAnswer.value).forEach(item => {
  //   console.log(item);
  //   if (item !== '') { tmpCheck += 1; }
  // });
  // if (tmpCheck >= inputIdx.value) {
  //   answerNoti();
  // } else {
  //   notiAnswer !== null && notiAnswer();
  //   notiAnswer = null;
  // }
  // if (typ) {
  //   console.log(problems[problemOrder.value]);
  //   problem.value = {
  //     ...problem.value, answer: { ...tmpAnswer.value }
  //   }
  // }
}
const setRelationAnswer = (val) => {
  // soundEffect('tic');
  problems[problemOrder.value]['relationResult'] = val;
  // setNotiNavigation(problems[problemOrder.value]);
}

const setNotiNav = (v = false) => {
  if (!isScored && v) {
    answerNoti();
  }

  if (notiNav === null && (notiType !== 'last' || isScored)) {
    notiNav = $q.notify({
      group: false,
      timeout: 0,
      message: '',
      color: 'blue-6',
      classes: 'force-inline',
      position: 'bottom-right',
      multiLine: true,
      actions:
        notiType === 'last' && isScored ? [
          { label: '개념학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }] : [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }]
    })
  }

  if (notiType !== 'first') {
    if (notiNavBack === null) {
      notiNavBack = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'grey-12',
        classes: 'force-inline',
        position: 'bottom-left',
        multiLine: true,
        actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
      })
    };
  }
}

const setNotiNavigation = (p, allCheck = false) => {
  // notiClear();
  // console.log(p);
  if (p?.done === true) {
    if (notiType !== 'first') {
      if (notiNavBack === null) notiNavBack = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'grey-12',
        classes: 'force-inline',
        position: 'bottom-left',
        multiLine: true,
        actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
      });
    }
    if (p.videoUrl !== null) {
      if (notiAdditionalNav === null) notiAdditionalNav = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        multiLine: true,
        color: 'red-12',
        classes: 'force-inline',
        position: 'bottom-right',
        actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
      })
    }
    if (notiNav === null)
      notiNav = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'blue-6',
        classes: 'force-inline',
        position: 'bottom-right',
        multiLine: true,
        actions:
          notiType === 'last' && isScored ? Object.keys(drillProblems).length > 0 ? [
            { label: '드릴학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { drillInit(); } }] : [
            { label: '어휘학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }] : [{
              label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => {
                if (dialog.value !== false) {
                  // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
                  dialog.value = false;
                } problems[problemOrder.value]['done'] = true; nextStep();
              }
            }]
      })
    // } else if (p.result === null && !isDrill) {
  } else if (!isDrill) {
    if (isAllChecked || isDrill) {
      if (notiAdditionalNav === null)
        notiAdditionalNav = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          color: 'red-12',
          classes: 'force-inline',
          position: 'bottom-right',
          multiLine: true,
          actions: [
            { label: '정답 확인', color: 'white', handler: () => { setQuestionsResult(); } }]
        })
    }

    if (notiType === 'first') {
      if (notiNav === null) notiNav = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'blue-6',
        classes: 'force-inline',
        position: 'bottom-right',
        multiLine: true,
        actions:
          [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }]
      })
    } else if (notiType === 'last') {
      if (notiNavBack === null)
        notiNavBack = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          color: 'grey-12',
          classes: 'force-inline',
          position: 'bottom-left',
          multiLine: true,
          actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
        });
    } else {
      if (notiNavBack === null)
        notiNavBack = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          color: 'grey-12',
          classes: 'force-inline',
          position: 'bottom-left',
          multiLine: true,
          actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
        });
      if (notiNav === null) notiNav = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'blue-6',
        classes: 'force-inline',
        position: 'bottom-right',
        multiLine: true,
        actions:
          [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }]
      })
    }
  } else if (p.scrollCheck === true) {
    if (p.result.marking === 'halfWrong') {
      if (notiType !== 'first') {
        if (notiNavBack === null)
          notiNavBack = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            color: 'grey-12',
            classes: 'force-inline',
            position: 'bottom-left',
            multiLine: true,
            actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
          });
      }
      if (notiAdditionalNav === null)
        notiAdditionalNav = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          multiLine: true,
          color: 'red-12',
          classes: 'force-inline',
          position: 'bottom-right',
          actions: [{ label: '정답 확인', color: 'white', handler: () => { setQuestionsResult(); } }]
        })
    } else if (p.result.marking === 'right') {
      if (notiType !== 'first') {
        if (notiNavBack === null)
          notiNavBack = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            color: 'grey-12',
            classes: 'force-inline',
            position: 'bottom-left',
            multiLine: true,
            actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
          });
      }
      if (p.videoUrl !== null) {
        if (notiAdditionalNav === null)
          notiAdditionalNav = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            multiLine: true,
            color: 'red-12',
            classes: 'force-inline',
            position: 'bottom-right',
            actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
          })
      }
      if (notiNav === null) notiNav = $q.notify({
        group: false,
        timeout: 0,
        message: '',
        color: 'blue-6',
        classes: 'force-inline',
        position: 'bottom-right',
        multiLine: true,
        actions:
          notiType === 'last' && isScored ? Object.keys(drillProblems).length > 0 ? [
            { label: '드릴학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { drillInit(); } }] : [
            { label: '어휘학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }] : [{
              label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => {
                if (dialog.value !== false) {
                  // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
                  dialog.value = false;
                } problems[problemOrder.value]['done'] = true; nextStep();
              }
            }]
      })
    } else if (p.result.marking === 'halfRight') {
      if (notiType !== 'first') {
        if (notiNavBack === null)
          notiNavBack = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            color: 'grey-12',
            classes: 'force-inline',
            position: 'bottom-left',
            multiLine: true,
            actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
          });
      }

      if (p.videoUrl !== null) {
        if (notiAdditionalNav === null)
          notiAdditionalNav = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            multiLine: true,
            color: 'red-12',
            classes: 'force-inline',
            position: 'bottom-right',
            actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
          })
      }
      if (p.videoUrl === null || p.completeVideo === true) {
        if (notiNav === null) notiNav = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          color: 'blue-6',
          classes: 'force-inline',
          position: 'bottom-right',
          multiLine: true,
          actions:
            notiType === 'last' && isScored ? [
              { label: '드릴학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { drillInit(); } }] : [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { problems[problemOrder.value]['done'] = true; nextStep(); } }]
        })
      }
    } else if (p.result.marking === 'wrong') {
      if (notiType !== 'first') {
        if (notiNavBack === null)
          notiNavBack = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            color: 'grey-12',
            classes: 'force-inline',
            position: 'bottom-left',
            multiLine: true,
            actions: [{
              label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => {
                if (dialog.value !== false) {
                  // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
                  dialog.value = false;
                }; nextStep(false);
              }
            }],
          });
      }

      if (p.videoUrl !== null && p.relationResult) {
        if (notiAdditionalNav === null)
          notiAdditionalNav = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            multiLine: true,
            color: 'red-12',
            classes: 'force-inline',
            position: 'bottom-right',
            actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
          })
      }
      if ((p.relationId === null || p.relationResult) && (p.videoUrl === null || p.completeVideo === true)) {
        if (notiNav === null) notiNav = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          color: 'blue-6',
          classes: 'force-inline',
          position: 'bottom-right',
          multiLine: true,
          actions:
            notiType === 'last' && isScored ? Object.keys(drillProblems).length > 0 ? [
              { label: '드릴학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { drillInit(); } }] : [
              { label: '어휘학습', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep(); } }] : [{
                label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => {
                  if (dialog.value !== false) {
                    // 확인 문제 팝업이 활성화 되었을경우 강제 닫기
                    dialog.value = false;
                  } problems[problemOrder.value]['done'] = true; nextStep();
                }
              }]
        })
      }
    }
  } else {
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!');
    if (isDrill || p.result?.marking === 'halfWrong') {
      if (notiType !== 'first') {
        if (notiNavBack === null)
          notiNavBack = $q.notify({
            group: false,
            timeout: 0,
            message: '',
            color: 'grey-12',
            classes: 'force-inline',
            position: 'bottom-left',
            multiLine: true,
            actions: [{ label: '', icon: 'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
          });
      }
      if (notiAdditionalNav === null)
        notiAdditionalNav = $q.notify({
          group: false,
          timeout: 0,
          message: '',
          multiLine: true,
          color: 'red-12',
          classes: 'force-inline',
          position: 'bottom-right',
          actions: [{ label: '정답 확인', color: 'white', handler: () => { setQuestionsResult(); } }]
        })
    }
  }

}

const setQuestionsResult = () => {
  // soundEffect('result');
  notiAdditionalNav = null;
  if (isDrill) {
    const tmpIsRight = problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].answer;
    if (problems[problemOrder.value]['result']) {
      problems[problemOrder.value]['result'] = { marking: tmpIsRight ? 'halfRight' : 'wrong', answer: problems[problemOrder.value].answer }
      problem.value = { ...problems[problemOrder.value] };
    } else {
      if (!problems[problemOrder.value]['endDtm']) {
        problems[problemOrder.value]['endDtm'] = moment().format('YYYY-MM-DD HH:mm:ss');
      }
      // console.log('setQuestionsResult !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 000');
      // console.log(problems[problemOrder.value]['problemClassCode']);
      // console.log(tmpIsRight);
      if (problems[problemOrder.value]['problemClassCode'] === '2' && !tmpIsRight) {
        let tmpArr = {};
        let idx = 1;
        Object.entries(problems).forEach(([key, i]) => {
          if (i.analysisOrd !== problems[problemOrder.value].analysisOrd || Number(i.etcInfo.difficultCd) <= Number(problems[problemOrder.value].data.content.property.analysis.difficultCd)) {
            tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
            idx += 1;
          }
        });
        // console.log('setQuestionsResult !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 111');
        // console.log(tmpArr);
        problems = tmpArr;
        // problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) < Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
      } else if (problems[problemOrder.value]['problemClassCode'] === '3' && tmpIsRight) {
        let tmpArr = {};
        let idx = 1;
        Object.entries(problems).forEach(([key, i]) => {
          if (i.analysisOrd !== problems[problemOrder.value].analysisOrd || Number(i.data.content.property.analysis.difficultCd) >= Number(problems[problemOrder.value].data.content.property.analysis.difficultCd)) {
            tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
            idx += 1;
          }
        });
        // console.log('setQuestionsResult !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 2222');
        // console.log(tmpArr);
        problems = tmpArr;
        // problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) > Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
      }
      // console.log('setQuestionsResult !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
      // console.log(problems);
      problems[problemOrder.value]['result'] = { marking: problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].answer ? 'right' : 'halfWrong', answer: problems[problemOrder.value].answer }
      problem.value = { ...problems[problemOrder.value] };
      if (problemOrder.value >= Object.keys(problems).length) {
        notiType = 'last';
      }
    }
  } else {

    if (isScored) {
      problems[problemOrder.value]['result'] = { marking: problems[problemOrder.value].data.content.solution.answer.detail[0].answer === problems[problemOrder.value].answer ? 'halfRight' : 'wrong', answer: problems[problemOrder.value].answer }
      problem.value = { ...problems[problemOrder.value] };
    } else {
      isAllChecked = false;
      if (problems[(problemOrder.value)]['result'] === null) {
        problems[(problemOrder.value)]['studyTime'] = problems[(problemOrder.value)]['studyTime'] + Math.round(moment.duration(moment().diff(startTime)).asSeconds());
        if (!problems[problemOrder.value]['endDtm']) {
          problems[problemOrder.value]['endDtm'] = moment().format('YYYY-MM-DD HH:mm:ss');
        }
      }
      startTime = moment();
      const tmpData = [];
      let tmpDrillProblems = [];
      Object.entries(problems).forEach(([key, item]) => {
        const tmpIsRight = item.data.content.solution.answer.detail[0].answer === item.answer;
        if (tmpIsRight) {
          tmpData.push({ no: item.analysisOrd, marking: 'right', analysis: item.data.content.property.analysis.analysisNm, difficult: difficult[item.data.content.property.analysis.difficultCd].label })
          tmpDrillProblems = [...tmpDrillProblems, ...allProblems.filter(i => { return i.analysisOrd === item.analysisOrd && Number(i.difficultCd) > Number(item.data.content.property.analysis.difficultCd) })];
        } else {
          let tmpArr = _.sortBy([...allProblems.filter(i => { return i.analysisOrd === item.analysisOrd && Number(i.difficultCd) < Number(item.data.content.property.analysis.difficultCd) })], 'difficultCd').reverse();
          tmpData.push({ no: item.analysisOrd, marking: 'halfWrong', analysis: item.data.content.property.analysis.analysisNm, difficult: difficult[item.data.content.property.analysis.difficultCd].label })
          tmpDrillProblems = [...tmpDrillProblems, ...tmpArr];
        }
        item.result = { marking: tmpIsRight ? 'right' : 'halfWrong', answer: item.answer };
      });
      const total = _.countBy(tmpData, (i) => {
        return i.marking === 'right' ? 'right' : 'wrong';
      });
      resultData.value = { ...total, data: tmpData };
      // console.log('allProblems!!!!!!!!!!!!!!!!');
      // console.log(tmpDrillProblems);
      tmpDrillProblems.forEach((item, index) => {
        getKrtProblem({
          version: studyStore.exprVersion, problemId: item.problemId
          // version: '1.00.01', problemId: 382222
        }, (r) => {
          drillProblems = {
            ...drillProblems, [index + 1]: {
              problemNo: index + 1,
              problemId: r.content.problemId,
              analysisOrd: item.analysisOrd,
              etcInfo: getEtcInfo(r),
              data: r,
              studyTime: 0,
              answer: null,
              reAnswer: null,
              markingType: 'right', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
              videoTime: 0,
              relationResult: null,
              // correctiveStatus: false,
              // totalCnt: 0,
              // process: 1,
              // 하단 네비 조정을 위한 변수
              result: null,              // 채점 여부및 1,2차 정오답 
              done: false,               // 채점및 풀이 확인 완료여부
              scrollCheck: false,             // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
              relationId: r.content.property.problem?.relations.length > 0 ? r.content.property.problem?.relations[0].relationId : null,           // 확인 문제 있는지 여부
              completeVideo: false,         // 영상 시청 여부
              // TODO: 큐뱅크 해설영상 파싱필요 
              videoUrl: null,              // 해설 영상 여부
              // drill: problems[item.analysisOrd].result.marking === 'right' ? 'up' : 'down',
              prevLabel: difficult[problems[item.analysisOrd].data.content.property.analysis.difficultCd].label,
              problemClassCode: problems[item.analysisOrd].result.marking === 'right' ? '2' : '3',
              baseDifficult: problems[item.analysisOrd].etcInfo.difficultCd
            }
          }
          // console.log('drillProblems!!!!!!!!!!!!!!!!');
          // console.log(drillProblems);
        });
      });
      isScored = true;
      notiClear();
      // problem.value = problems[problemOrder.value];
      // problemOrder.value = 0;
      // problem.value = problems[0];
      // notiType = 'first'
      // resultDialog.value = true;
      store.openModal(true);
    }
  }
}

// 스크롤 하단시 액션
const onIntersection = () => {

  // console.log(' onIntersection !!!!!!!!!!!!!!!');
  // if (problem.value?.result?.marking === 'right' || problem.value?.result?.marking === 'halfRight') {
  //   notiNav !== null && notiNav();
  //   // TODO: 해설 영상이 있을 경우만 타게
  //   if (!videoDialog.value) {
  //     notiInfo !== null && notiInfo();
  //     notiInfo = $q.notify({
  //       group: false,
  //       //    timeout: 5,
  //       message: '확인해야 할 해설 영상이 있어요!',
  //      color: 'grey-12',
  //       classes: 'force-inline',
  //       position: 'bottom-right',
  //       multiLine: true,
  //       //    actions: [{ label: '틀렸어요', icon:  'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
  //     });
  //     notiNav = $q.notify({
  //       group: false,
  //       timeout: 0,
  //       message: '',
  //       multiLine: true,
  //       color: 'red-12',
  //       classes: 'force-inline',
  //       position: 'bottom-right',
  //       actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
  //     })
  //   } else {
  //     notiNav = $q.notify({
  //       group: false,
  //       timeout: 0,
  //       message: '',
  //       multiLine: true,
  //       color: 'primary',
  //       classes: 'force-inline',
  //       position: 'bottom-right',
  //       actions: [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep() } }]
  //     });
  //   }
  // } else if (problem.value?.result?.marking === 'wrong') {
  //   if (problems[problemOrder.value]['completeVideo'] === true && problem.value.relationResult) {
  //     notiNav = $q.notify({
  //       group: false,
  //       timeout: 0,
  //       message: '',
  //       multiLine: true,
  //       color: 'primary',
  //       classes: 'force-inline',
  //       position: 'bottom-right',
  //       actions: [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'white', handler: () => { nextStep() } }]
  //     });
  //   } else if (problem.value.relationResult && !problems[problemOrder.value]['completeVideo']) {
  //     notiNav = $q.notify({
  //       group: false,
  //       timeout: 0,
  //       message: '',
  //       multiLine: true,
  //       color: 'red-12',
  //       classes: 'force-inline',
  //       position: 'bottom-right',
  //       actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
  //     })
  //   }
  // }
  if (problems[problemOrder.value]['scrollCheck'] !== true) {
    problems[problemOrder.value]['scrollCheck'] = true;
    // setNotiNavigation(problems[problemOrder.value]);
  }
}

const onVideoDialogHide = () => {
  // console.log('onVideoDialogHide');
  videoDialog.value = false;
  notiInfo !== null && notiInfo();
  notiNav !== null && notiNav();
  notiInfo !== null && notiInfo();
  notiNav = null;
  if (problems[problemOrder.value]['completeVideo'] !== true && problem.value?.result?.marking !== 'right') {
    notiInfo = $q.notify({
      group: false,
      //    timeout: 5,
      message: '영상을 시청 완료해야 다음으로 넘어갈 수 있어요!',
      // color: 'secondary',
      classes: 'force-inline',
      position: 'right',
      multiLine: true,
      //    actions: [{ label: '틀렸어요', icon:  'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }],
    });
    // notiNav = $q.notify({
    //   group: false,
    //   timeout: 0,
    //   message: '',
    //   multiLine: true,
    //   color: 'red-12',
    //   classes: 'force-inline',
    //   position: 'bottom-right',
    //   actions: [{ label: '해설 영상', color: 'white', handler: () => { videoDialog.value = true; } }]
    // })
  } else {
    // setNotiNav();
    setNotiNavigation(problems[problemOrder.value]);
  }
}
const onRelationDialogHide = () => {
  // notiInfo !== null && notiInfo();
  // notiNav !== null && notiNav();
  // notiNav = null;
  if (relationId.value === problemOrder.value && problems[relationId.value]['relationResult'] === null) {
    notiInfo = $q.notify({
      group: false,
      //    timeout: 5,
      message: '확인문제 풀이를 완료해야 다음으로 넘어갈 수 있어요!',
      // color: 'secondary',
      classes: 'force-inline',
      position: 'right',
      multiLine: true,
      //    actions: [{ label: '틀렸어요', icon:  'arrow_back_ios_new', color: 'grey-6', handler: () => { nextStep(false); } }]  ,
    });
  }
  // else {
  //   // setNotiNav();
  //   setNotiNavigation(problems[problemOrder.value]);
  // }
}

const setVideoStatus = () => {
  problems[problemOrder.value]['completeVideo'] = true;
  // setNotiNavigation(problems[problemOrder.value]);
  // console.log(problems[problemOrder.value]);
}

const setScrollPosition = (val = 0) => {
  scrollAreaRef.value.setScrollPosition('vertical', 0);
}

const drillInit = () => {
  baseProblems = problems;
  problems = drillProblems;
  problem.value = drillProblems[1];
  isScored = false;
  isDrill = true;
  notiType = 'first';
  nextStep(false, 1);
  // problemOrder.value = 1;
}

const saveResult = () => {
  // let tmpRs = [];
  // const addRs = (arr) => {
  //   Object.entries(arr).forEach(([key, value]) => {
  //     let tmpVal = { ...value };
  //     tmpVal.rightAnswer = tmpVal.data.content.solution.answer.detail[0].answer;
  //     tmpVal.answer = tmpVal.answer;
  //     tmpVal.isRight = problem.value?.result?.marking === 'right';
  //     tmpVal.reAnswer = tmpVal.reAnswer;
  //     tmpVal.reAnswerIsRight = tmpVal.reAnswer === null ? null : problem.value?.result?.marking === 'halfRight';
  //     delete tmpVal.problemNo;
  //     delete tmpVal.analysisOrd;
  //     delete tmpVal.etcInfo;
  //     delete tmpVal.data;
  //     delete tmpVal.type;
  //     delete tmpVal.markingType;

  //     // TODO: 비디오 시간 필요 여부
  //     delete tmpVal.videoTime;
  //     delete tmpVal.relationResult;
  //     delete tmpVal.result;
  //     delete tmpVal.done;
  //     delete tmpVal.scrollCheck;
  //     delete tmpVal.relationId;
  //     delete tmpVal.completeVideo;
  //     delete tmpVal.videoUrl;

  //     delete tmpVal.baseDifficult;
  //     delete tmpVal.prevLabel;
  //     tmpRs.push(tmpVal);
  //   })
  // }
  // addRs(baseProblems);
  // addRs(problems);
  // const saveData = {
  //   examNm: studyStore.process.exam.examCode,
  //   exprVersion: studyStore.exprVersion,
  //   type: studyStore.process.exam.type,
  //   // cornerTime,
  //   submission: tmpRs
  // }
  // console.log('saveData %%%%%%%%%%%%%%%%%%%%%%%%%');
  // console.log(saveData);
  // postAnswerEarnest(saveData, () => {
  //   // router.push('/vocabularylearning');
  // })
}


const levelModel = ref({ "label": "1레벨", "value": "01" });
const lessonModel = ref({ "label": "1레슨", "value": "01" });
const lnModel = ref({ label: '문학', value: 'L' });
const options = ref(stringOptions);
const levelOptions = [{ label: '1레벨', value: '01' }, { label: '2레벨', value: '02' }, { label: '3레벨', value: '03' }];
const lessonList = [...Array(97)].map((i, index) => {
  return { label: (index + 1) + '레슨', value: index > 9 ? ((index + 1) + '') : ('0' + (index + 1)) };
});
const lnOptions = [{ label: '문학', value: 'L' }, { label: '비문학', value: 'N' }];
const model = ref('KRT_01_01_L_01');

watch(() => model.value, (newValue) => {
  // let strArr = model.value.replace('KRT_', '').split('_');
  // console.log(strArr);
  // isLoading.value = true;
  // isKreadVisible.value = false;
  // problemOrder.value = 0;
  // initExams(newValue);
});

const stringOptions = examsData;
model.value = stringOptions[0];

const filterFn = (val, update, abort) => {
  update(() => {
    const needle = val.toLowerCase()
    options.value = [...stringOptions].filter(v => v.toLowerCase().indexOf(needle) > -1)
  })
}

const modelChange = () => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ modelChange');
  const tmp = "KRT_" + (levelModel.value.value) + "_" + (lessonModel.value.value) + "_" + (lnModel.value.value);
  console.log(tmp);
  const tmpFilter = [...examsData].filter(v => v.indexOf(tmp) > -1)
  console.log(tmpFilter);
  model.value = tmpFilter.pop();
  initExams(model.value);
}
const examModelChange = () => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ examModelChange');
  let strArr = model.value.replace('KRT_', '').split('_');
  console.log(strArr);
  const tmpLevel = [...levelOptions].filter(v => v.value === strArr[0]).pop();
  const tmpLesson = [...lessonList].filter(v => v.value === strArr[1]).pop();
  const tmpLn = [...lnOptions].filter(v => v.value === strArr[2]).pop();

  console.log(tmpLevel);
  console.log(tmpLesson);
  console.log(tmpLn);
  console.log(lessonList);


  levelModel.value = tmpLevel;
  lessonModel.value = tmpLesson;
  lnModel.value = tmpLn;
  isLoading.value = true;
  isKreadVisible.value = false;
  problemOrder.value = 0;
  initExams(model.value);
}

const nextExam = (back = false) => {
  console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
  console.log(stringOptions);
  console.log(model.value);
  // const fIndex = stringOptions.findIndex((e, i) => { e === model.value });
  const fIndex = _.findIndex(stringOptions, function (o) { return o === model.value; });
  console.log(fIndex);
  if (back) {
    if (fIndex !== 0)
      model.value = stringOptions[fIndex - 1]
  } else {
    if (fIndex !== stringOptions.length - 1)
      model.value = stringOptions[fIndex + 1]
  }

  let strArr = model.value.replace('KRT_', '').split('_');
  console.log(strArr);
  const tmpLevel = [...levelOptions].filter(v => v.value === strArr[0]).pop();
  const tmpLesson = [...lessonList].filter(v => v.value === strArr[1]).pop();
  const tmpLn = [...lnOptions].filter(v => v.value === strArr[2]).pop();

  console.log(tmpLevel);
  console.log(tmpLesson);
  console.log(tmpLn);
  console.log(lessonList);


  levelModel.value = tmpLevel;
  lessonModel.value = tmpLesson;
  lnModel.value = tmpLn;
  isLoading.value = true;
  isKreadVisible.value = false;
  problemOrder.value = 0;
  initExams(model.value);
}

const onClickHome = () => {
  store.openConfirmDialog({
    message: '중단하고 홈으로 이동하시겠습니까?',
    cancel: '닫기',
    ok: '확인',
    callback: () => { router.push('/learninghome') },
  });
}
</script>

<style scoped lang="scss">
.word-chart_item {
  padding: 0px 20px;
  text-align: center;
}

.q-dialog__backdrop {
  width: 100vw;
  height: 100vh;
  top: 0px;
  position: fixed;
  z-index: 6000;
  pointer-events: all;
  outline: 0;
  background: rgb(23 20 20 / 40%);
}

::v-deep {
  .q-scrollarea__bar--v,
  .q-scrollarea__thumb--v {
      width: 0.3vw;
  }
}
</style>
